var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInactiveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-2",
    fillRule: "evenodd",
    d: "M20.39590737 8.54716457c-.11250267-.08099888-.26850638-.05499924-.34900829.05749921l-8.07869176 11.26034496-3.0415722-3.04145812c-.0975023-.09749866-.25600607-.09749866-.35350838 0-.09750232.09749866-.09750232.25599647 0 .35349513l3.25007714 3.24995526c.04700112.04699935.11050262.07299899.17650419.07299899.00700017 0 .01350032 0 .02050049-.0005.07300173-.00599991.14000332-.04399939.18300434-.10349857l8.25019583-11.49984166c.0800019-.11249845.0545013-.2684963-.05750136-.3489952z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.5,
    cy: 14.5,
    fill: "none",
    stroke: "rgb(151,151,151)",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 1,
    rx: 14,
    ry: 14
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "rgb(151,151,151)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0,
    stroke: "rgb(151,151,151)",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 1,
    xlinkHref: "#path-2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveIcon);
export default __webpack_public_path__ + "static/media/inactive-icon.917ea155.svg";
export { ForwardRef as ReactComponent };